<template>
  <section>
    <base-card>
      <h2>Page not found</h2>
      <p>
        This page could not be found - maybe head to the home page
        <router-link to="/home">home page</router-link>.
      </p>
    </base-card>
  </section>
</template>